import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import ToDoModule from './ToDoModule';

export function SortableToDo(props) {
    const {
            attributes,
            listeners,
            setNodeRef,
            transform,
            transition,
    } = useSortable({id: props.id});

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <div className='sortable sortable--todo' ref={setNodeRef} style={style}>
            <ToDoModule
                data={props.data}
                parentController={props.parentController}
                deleteAction={props.deleteAction}
                animate={props.animate}
                sortData={{attributes: attributes, listeners: listeners}}
            /> 
        </div>
    );
}